import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import { Button } from "../../../uiKit/Button/Button"
import { Modal } from "../../../uiKit/Modal/Modal"
import * as React from "react"
import { LoadingOverlay } from "../../../uiKit/LoadingOverlay/LoadingOverlay"

type Props = {
    isOpen: boolean
    itemName: Maybe<string>
    isLoading: boolean
    onClose: () => void
    onConfirm: () => void
    label: string
}

export const DuplicateItemConfirmModal = (props: Props) => {
    return (
        <Modal isVisible={props.isOpen} onClose={props.onClose} size="tiny" verticalCentered={true}>
            {props.isLoading ? <LoadingOverlay caption="Duplicating item..." /> : null}
            <div className={classes.wrap}>
                <div className={classes.title}>
                    Are you sure you want to duplicate {props.itemName ? `'${props.itemName}'` : "item"}?
                </div>
                <div className={classes.label}>{props.label}</div>
                <div className={classes.btnsWrap1}>
                    <Button className={classes.actionBtn} onClick={props.onClose}>
                        Cancel
                    </Button>
                    <Button className={classes.actionBtn} type="primary" onClick={props.onConfirm}>
                        Duplicate
                    </Button>
                </div>
            </div>
        </Modal>
    )
}

const classes = {
    wrap: "-m-1 pt-1",
    title: "mb-2.5 mt-2 text-18 font-bold leading-7",
    label: "mb-6 text-14",
    btnsWrap1: "flex justify-end space-x-2",
    actionBtn: "min-w-[120px]",
}
